import { useState, useEffect } from "react";
import "../css/SuppliersPanel.css";
import InputIconSearch from "../components/InputIconSearch";
import DataTable from "react-data-table-component";
import CheckBox from "../components/CheckBox";
import ButtonIconH from "../components/ButtonIconH";
import SupplierCard from "../components/SupplierCard";
import { post } from "../js/post";
import { supplierStructure, userData } from "../js/utils";
import { formatValueUnit } from "../js/utils";
import "../css/Store.css";
import "../css/DeliveryNote.css";
import { rightStyle } from "../js/tableColumns";

export default function Suppliers(props) {
  const [inputSearch, setInputSearch] = useState("");
  const [supplierList, setSupplierList] = useState([]);
  const [currentSupplier, setCurrentSupplier] = useState(null);
  const [suppliersToDelete, setSuppliersToDelete] = useState([]);

  const columns = [
    {
      name: "Empresa",
      selector: (row) => row.nombre,
      sortable: true,
      width: "20%",
    },
    {
      name: "NIF",
      selector: (row) => row.nif,
      sortable: true,
      width: "15%",
    },
    {
      name: "Código",
      selector: (row) => row.codigo,
      sortable: true,
      width: "15%",
    },
    {
      name: "Teléfono",
      selector: (row) => row.telefono,
      sortable: true,
      width: "10%",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "20%",
    },
    {
      name: "Contacto",
      selector: (row) => row.contacto,
      sortable: true,
      width: "18%",
    },
    {
      name: "",
      sortable: false,
      width: "2%",
      cell: (row) =>
        row.modificable && (
          <div
            onClick={() => {
              setSuppliersToDelete((prev) =>
                !prev.includes(row.id)
                  ? [...prev, row.id]
                  : prev.filter((id) => id !== row.id),
              );
            }}
          >
            <CheckBox
              active={suppliersToDelete.includes(row.id)}
              onClick={() => {}}
            ></CheckBox>
          </div>
        ),
    },
  ];

  const getSupplier = async (id) => {
    const response = await post("ObtenerProveedor.php", {
      token: userData.token,
      idProveedor: id,
    });
    setCurrentSupplier(response);
  };

  const deleteSuppliers = async () => {
    await Promise.all(
      suppliersToDelete.map(async (e) => {
        await post("EliminarProveedor.php", {
          token: userData.token,
          idProveedor: e,
          idUsuario: userData.id,
        });
      }),
    );
    setSuppliersToDelete([]);
  };

  async function getSuppliers() {
    const response = await post("ListarProveedores.php", {
      token: userData.token,
      familia: -1,
      inputFiltro: inputSearch,
      categoria: "",
    });
    setSupplierList(response);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getSuppliers();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputSearch]);

  if (!props.show) {
    return <></>;
  }
  return (
    <div className="patient-data">
      {currentSupplier !== null && (
        <SupplierCard
          supplier={currentSupplier}
          onClose={async () => {
            await getSuppliers();
            setCurrentSupplier(null);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        ></SupplierCard>
      )}
      <div className="patient-data-header">
        <span className="header-text">Proveedores</span>
        <div className="patient-header-buttons"></div>
      </div>
      <div className="patient-data-content store-data-content suppliers-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Almacén</span>
            <span>|</span>
            <span className="signed-text">Proveedores</span>
          </div>
        </div>
        <div className="patient-info store-info supplier-container">
          <div className="opt-table-title opt-table-title-button">
            Búsqueda de proveedores
          </div>
          <div className="data-field supplier-search">
            <span className="label">Empresa/NIF/Teléfono/Contacto/...</span>
            <InputIconSearch
              tabIndex={500}
              type="type-alphanum-ext"
              size={2}
              highlight={true}
              input={inputSearch}
              onChange={(e) => {
                setInputSearch(e);
              }}
              onClear={() => {
                setInputSearch("");
              }}
            ></InputIconSearch>
          </div>
        </div>
        <div
          className="patient-info store-info supplier-container supplier-container-full"
          style={{ position: "relative" }}
        >
          <div
            style={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
          ></div>
          <div className="opt-table-title opt-table-title-button">
            <div>
              Listado de proveedores ({formatValueUnit(supplierList.length)})
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <ButtonIconH
                text="Nuevo proveedor"
                highlight={true}
                small={true}
                onClick={async () => {
                  setCurrentSupplier(supplierStructure);
                }}
              ></ButtonIconH>
              <ButtonIconH
                text="Eliminar seleccionados"
                small={true}
                onClick={async () => {
                  if (suppliersToDelete.length > 0) {
                    props.createPopupQuestion(
                      `¿Desea eliminar los proveedores seleccionados?`,
                      async () => {
                        await deleteSuppliers();
                        props.removePopupQuestion();
                        await getSuppliers();
                      },
                      () => {
                        props.removePopupQuestion();
                      },
                    );
                  }
                }}
              ></ButtonIconH>
            </div>
          </div>
          <div className="suppliers-table">
            <DataTable
              columns={columns}
              data={supplierList}
              className="custom-datatable"
              noDataComponent="No hay proveedores disponibles."
              onRowClicked={async (row) => {
                await getSupplier(row.id);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
